import React from "react";
import { Carousel } from "antd";
export default function CommonCarousel(props: any) {
  return (
    <Carousel autoplay draggable dots={false}>
      {props.carousel}
    </Carousel>
  );
}
